import MuiAlert from '@material-ui/lab/Alert'
import Snackbar from '@material-ui/core/Snackbar'
import { MessageType } from '../context/SessionContext'

/**
 * Custom `ActionsOptType` component declaration.
 * @param {Boolean} open
 * @param {String} message
 * @param {MessageType} type
 * @return ActionsOptType
 */
export type ActionsOptType = { open: boolean; message: string | null; type?: MessageType | null }

// Define AlertProps interface
interface AlertProps {
  alertOptions: ActionsOptType
  setAlertOptions: (newState: ActionsOptType) => void
}

/**
 * Custom `Alert` component declaration.
 * @param alertOptions
 * @param setAlertOptions
 * @return Alert
*/
export default function Alert({alertOptions, setAlertOptions}: AlertProps): JSX.Element {
  
  const handleClose = (_event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    setAlertOptions({...alertOptions, open: false})
  }

  return (
    <Snackbar open={alertOptions.open} autoHideDuration={6000} onClose={handleClose}>
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={handleClose}
        severity={alertOptions.type || 'error'}
      >
        {alertOptions.message}
      </MuiAlert>
    </Snackbar>
  )
}